import { ReactNode } from "react";
import { useOverlays } from "contexts/OverlayContext";
import { PlainModal } from "@design-system/Modal/Modal";
import { ConfigurePermissionsModal } from "./ConfigurePermissionsModal";
import { useMemberManagementDefaults } from "./useMemberManagementDefaults";
import { MemberManagementOverlayEntity } from "./memberManagement.types";

interface MemberManagementConfigurePermissionsOverlayData {
    member: Parameters<typeof ConfigurePermissionsModal>[0]["member"];
    onClose?: () => void;
    workspaceId?: string;
    actingUserRole?: Parameters<
        typeof ConfigurePermissionsModal
    >[0]["actingUserRole"];
    entities?: MemberManagementOverlayEntity[];
    configurePermissionsHeader?: ReactNode;
}

interface MemberManagementConfigurePermissionsModalContentProps {
    overlayData: MemberManagementConfigurePermissionsOverlayData;
    closeOverlay: () => void;
    overlayIsClosing: boolean;
}

const MemberManagementConfigurePermissionsModalContent = ({
    overlayData,
    closeOverlay,
    overlayIsClosing,
}: MemberManagementConfigurePermissionsModalContentProps) => {
    const { workspaceId, actingUserRole, entities } =
        useMemberManagementDefaults(overlayData);

    const { member, onClose, configurePermissionsHeader } = overlayData;

    if (!workspaceId || !actingUserRole) {
        return null;
    }

    const handleClose = () => {
        closeOverlay();
        onClose?.();
    };

    return (
        <PlainModal show={!overlayIsClosing} onHide={handleClose}>
            <ConfigurePermissionsModal
                header={configurePermissionsHeader}
                actingUserRole={actingUserRole}
                member={member}
                workspaceId={workspaceId}
                entities={entities}
                closeModal={handleClose}
            />
        </PlainModal>
    );
};

export const MemberManagementConfigurePermissionsModalOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("memberManagementConfigurePermissions");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <MemberManagementConfigurePermissionsModalContent
            overlayData={overlayInfo.data}
            closeOverlay={closeOverlay}
            overlayIsClosing={overlayIsClosing}
        />
    );
};
